import { useTranslation } from "react-i18next";
import {
  LoginHeading,
  Logo,
  LoginContainer,
  LoginPage,
  LoginDisclaimer,
  LoginInformationSection,
  LoginSummary,
  LoginLogoHeader,
  LoginCarouselContainer,
} from "./loginRedirect.styled";
import { useContext } from "react";
import { AuthContext } from "core/contexts/auth/auth";
import Carousel from "core/components/global/carousel/carousel";
import AccentureLogoTransparent from "assets/AccentureLogoTransparent";
import AccentureMySecAiLogo from "assets/AccentureMySecAiLogo";

function LoginRedirect({ product }) {
  const { loginAF, loginAMS } = useContext(AuthContext);
  const { t } = useTranslation();

  return (
    <LoginPage className="w-100 h-100">
      <LoginInformationSection className="h-100 p-3 position-relative">
        <span className="z-index-1 position-absolute">
          <Logo
            size={"full"}
          >
            <AccentureLogoTransparent/>
          </Logo>
        </span>
        <LoginLogoHeader className="d-flex justify-content-center flex-row align-items-center ">
          <Logo
            size={"xl"}
          >
            <AccentureMySecAiLogo/>
          </Logo>
          <h3 className="ms-2">{t(`LOGIN.${product}`)}</h3>
        </LoginLogoHeader>

        <div className="z-index-2 w-100 d-flex flex-column align-items-center justify-content-center">
          <LoginHeading>
            <h1>Your security,</h1>
            <h1>reinvented</h1>
          </LoginHeading>

          <LoginSummary className="mb-6">
            <p>Access Accenture Security's AI Enabled</p>
            <p>Assistant & Agents</p>
          </LoginSummary>

          <LoginContainer className="mt-3 col-md-8 d-flex justify-content-center">
            <div className="d-flex justify-content-center flex-column">
              <button
                onClick={() => {
                  {
                    product === "AC2FLYWHEEL" ? loginAF() : loginAMS();
                  }
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-indigo to-purple rounded-lg" />
                <div className="p-2 rounded-[6px] relative group transition duration-200">
                  <h3>{t("LOGIN.LOGIN_IN_BUTTON")} with SSO</h3>
                </div>
              </button>
              <LoginDisclaimer className="mt-3 align-self-center">
                <div className="d-flex flex-row flex-wrap justify-content-center">
                  <div className="d-flex flex-wrap justify-content-center"><p className="m-0">By continuing, you </p> <p className="m-0">acknowledge Accenture's </p></div>
                  <a
                    className="ms-1 pe-1"
                    href="https://www.accenture.com/in-en/support/terms-of-use"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms and Conditions
                  </a>
                  <p className="m-0">and </p>
                  <a
                    className="ms-1"
                    href="https://www.accenture.com/us-en/support/privacy-policy"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                  .
                </div>
              </LoginDisclaimer>
            </div>
          </LoginContainer>
        </div>
      </LoginInformationSection>
      <LoginCarouselContainer>
        <Carousel />
      </LoginCarouselContainer>
    </LoginPage>
  );
}

export default LoginRedirect;